import NoDataComponent from "../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const agriculture_no_data = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Agricultural Businesses"
      subheaderinfo="Agricultural Businesses will appear here"
    />
  );
};

export default agriculture_no_data;